import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

import {FacadePaginateBaseModel} from '@shared/presentation/facade.paginate.base.model';

import {ListProductUseCasePort} from '@features/product/application/use_cases/list-product/list-product.use-case.port';
import {ListProductPayloadDto} from '@features/product/application/use_cases/list-product/dto/list-product.payload.dto';
import {
  ListProductResponseDto
} from '@features/product/application/use_cases/list-product/dto/list-product.response.dto';
import {finalize, firstValueFrom} from 'rxjs';

@Injectable({providedIn: "root"})
export class ListProductFacade extends FacadePaginateBaseModel<ListProductResponseDto | null> {

  private readonly destroyRef = inject(DestroyRef);
  private readonly useCase = inject(ListProductUseCasePort);

  constructor() {
    super(null);
  }

  public load(payload: ListProductPayloadDto): void {
    if (this.loading()) {
      return;
    }

    this.resetEvents();
    this.setLoading();

    this.useCase.execute(payload)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          this.setIdle()
        })
      )
      .subscribe({
        next: (response) => {
          this.setData(response);
          if (response.meta) {
            const {current_page, from, last_page, to, total, per_page} = response.meta;
            this.setMeta({
              from,
              to,
              currentPage: current_page,
              limit: per_page,
              total,
              lastPage: last_page,
            });
          }
          this.setSuccess('Proceso exitoso!');
        },
        error: (error: unknown) => {
          this.setError(this.getErrorMessage(error));
        },
      });
  }

  public async loadPromise(payload: ListProductPayloadDto): Promise<ListProductResponseDto> {
    return firstValueFrom(this.useCase.execute(payload));
  }

  public clear(): void {
    this.reset();
  }

}
